import { SchemaEnvironment } from "schema/environment";
import { setEnvironment } from "constants/environment";

export const getEnvironment = async () => {
  try {
    const response = await fetch("/config.json");
    const config = await response.json();
    const validate = SchemaEnvironment.safeParse(config);

    if (!validate.success) console.warn(validate.error);
    setEnvironment(config);

    return config;
  } catch (error) {
    console.error("Error fetching environment:", error);
    throw error;
  }
};
